module.exports = __webpack_public_path__ + "images/bannerDE-94bc3d5acfbbfad19867659afa13f184.png";